import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { isAppReady } from '../../store/reducers';
import { auth } from '../../store/reducers';

@Injectable()
export class AuthenticatedGuard implements CanActivate {
  private appready: Observable<boolean>;
  private authenticated: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.appready = this.store.select(isAppReady);
    this.authenticated = this.store.select(auth.getLoggedIn);
  }

  public canActivate() {
    return true;
  }

  /*
  public canActivate(): Observable<boolean> {
    return this.appready.pipe(
      filter(ready => ready),
      withLatestFrom(this.authenticated),
      switchMap(([refreshed, authData]) => {
        if (!authData) {
          this.store.dispatch(actions.NavigateAction({ path: ['/auth'] }));
        }
        return observableOf(authData);
      }),);
  }
  */
}
